"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyPlaceholderWidget = exports.newLoadingPlaceholderWidget = exports.newInitialPlaceholderWidget = exports.newPlaceholderWidget = exports.PLACEHOLDER_WIDGET_ID = exports.isLoadingPlaceholderWidget = exports.isInitialPlaceholderWidget = exports.isPlaceholderWidget = exports.newInsightPlaceholderWidget = exports.INSIGHT_PLACEHOLDER_WIDGET_ID = exports.isInsightPlaceholderWidget = exports.newKpiPlaceholderWidget = exports.KPI_PLACEHOLDER_WIDGET_ID = exports.isKpiPlaceholderWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var layoutTypes_1 = require("../../model/types/layoutTypes");
/**
 * Tests whether an object is a {@link KpiPlaceholderWidget}.
 *
 * @param obj - object to test
 * @alpha
 */
function isKpiPlaceholderWidget(obj) {
    return !isEmpty_1.default(obj) && obj.customType === "gd-kpi-placeholder";
}
exports.isKpiPlaceholderWidget = isKpiPlaceholderWidget;
/**
 * @internal
 */
exports.KPI_PLACEHOLDER_WIDGET_ID = "__kpiPlaceholder__";
/**
 * @alpha
 */
function newKpiPlaceholderWidget() {
    return layoutTypes_1.newCustomWidget(exports.KPI_PLACEHOLDER_WIDGET_ID, "gd-kpi-placeholder");
}
exports.newKpiPlaceholderWidget = newKpiPlaceholderWidget;
/**
 * Tests whether an object is a {@link InsightPlaceholderWidget}.
 *
 * @param obj - object to test
 * @alpha
 */
function isInsightPlaceholderWidget(obj) {
    return !isEmpty_1.default(obj) && obj.customType === "gd-insight-placeholder";
}
exports.isInsightPlaceholderWidget = isInsightPlaceholderWidget;
/**
 * @internal
 */
exports.INSIGHT_PLACEHOLDER_WIDGET_ID = "__insightPlaceholder__";
/**
 * @alpha
 */
function newInsightPlaceholderWidget() {
    return layoutTypes_1.newCustomWidget(exports.INSIGHT_PLACEHOLDER_WIDGET_ID, "gd-insight-placeholder");
}
exports.newInsightPlaceholderWidget = newInsightPlaceholderWidget;
/**
 * Tests whether an object is a {@link PlaceholderWidget}.
 *
 * @param obj - object to test
 * @alpha
 */
function isPlaceholderWidget(obj) {
    return !isEmpty_1.default(obj) && obj.customType === "gd-widget-placeholder";
}
exports.isPlaceholderWidget = isPlaceholderWidget;
/**
 * Tests whether an object is a {@link PlaceholderWidget} and is initial.
 *
 * @param obj - object to test
 * @internal
 */
function isInitialPlaceholderWidget(obj) {
    return isPlaceholderWidget(obj) && !!obj.isInitial;
}
exports.isInitialPlaceholderWidget = isInitialPlaceholderWidget;
/**
 * Tests whether an object is a {@link PlaceholderWidget} and is loading.
 *
 * @param obj - object to test
 * @internal
 */
function isLoadingPlaceholderWidget(obj) {
    return isPlaceholderWidget(obj) && !!obj.isLoading;
}
exports.isLoadingPlaceholderWidget = isLoadingPlaceholderWidget;
/**
 * @internal
 */
exports.PLACEHOLDER_WIDGET_ID = "__placeholder__";
/**
 * @alpha
 */
function newPlaceholderWidget() {
    return layoutTypes_1.newCustomWidget(exports.PLACEHOLDER_WIDGET_ID, "gd-widget-placeholder");
}
exports.newPlaceholderWidget = newPlaceholderWidget;
/**
 * @internal
 */
function newInitialPlaceholderWidget() {
    return layoutTypes_1.newCustomWidget(exports.PLACEHOLDER_WIDGET_ID, "gd-widget-placeholder", {
        isInitial: true,
    });
}
exports.newInitialPlaceholderWidget = newInitialPlaceholderWidget;
/**
 * @internal
 */
function newLoadingPlaceholderWidget() {
    return layoutTypes_1.newCustomWidget(exports.PLACEHOLDER_WIDGET_ID, "gd-widget-placeholder", {
        isLoading: true,
    });
}
exports.newLoadingPlaceholderWidget = newLoadingPlaceholderWidget;
/**
 * Tests whether an object is any type of placeholder widgets.
 *
 * @param obj - object to test
 * @alpha
 */
function isAnyPlaceholderWidget(obj) {
    return isPlaceholderWidget(obj) || isInsightPlaceholderWidget(obj) || isKpiPlaceholderWidget(obj);
}
exports.isAnyPlaceholderWidget = isAnyPlaceholderWidget;
//# sourceMappingURL=types.js.map